"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonDisplayErrors = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PrimaryButton = require("./PrimaryButton");

var _SecondaryButton = require("./SecondaryButton");

var _TertiaryButton = require("./TertiaryButton");

var _ButtonLayoutWrapper = require("./ButtonLayoutWrapper");

var _btnPropTypes = require("./btnPropTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ButtonDisplayErrors = function ButtonDisplayErrors(_ref) {
  var type = _ref.type,
      btnText = _ref.btnText,
      cashbotName = _ref.cashbotName,
      children = _ref.children,
      isSmall = _ref.isSmall,
      isPrimary = _ref.isPrimary,
      isTertiary = _ref.isTertiary,
      onClick = _ref.onClick,
      doFocus = _ref.doFocus,
      icon = _ref.icon,
      isLeftAligned = _ref.isLeftAligned,
      isInline = _ref.isInline,
      showLoading = _ref.showLoading,
      ariaDescribedBy = _ref.ariaDescribedBy,
      showChildrenBelow = _ref.showChildrenBelow;
  var buttonProps = {
    type: type,
    btnText: btnText,
    cashbotName: cashbotName,
    isSmall: isSmall,
    isLeftAligned: isLeftAligned,
    isInline: isInline,
    onClick: onClick,
    doFocus: doFocus,
    showLoading: showLoading,
    ariaDescribedBy: ariaDescribedBy
  };
  return _react.default.createElement(_ButtonLayoutWrapper.ButtonLayoutWrapper, {
    isSmall: isSmall
  }, !showChildrenBelow && children, !isTertiary && (isPrimary ? _react.default.createElement(_PrimaryButton.InnerPrimaryButton, buttonProps) : _react.default.createElement(_SecondaryButton.InnerSecondaryButton, buttonProps)), isTertiary && _react.default.createElement(_TertiaryButton.TertiaryButton, _extends({}, buttonProps, {
    icon: icon
  })), showChildrenBelow && children);
};

exports.ButtonDisplayErrors = ButtonDisplayErrors;
ButtonDisplayErrors.defaultProps = _objectSpread({}, _btnPropTypes.tertiaryBtnDefaults, {
  isPrimary: true,
  isTertiary: false,
  showLoading: false,
  showChildrenBelow: false
});
ButtonDisplayErrors.propTypes = _objectSpread({}, _btnPropTypes.tertiaryBtnPropTypes, {
  isPrimary: _propTypes.default.bool,
  isTertiary: _propTypes.default.bool,
  showLoading: _propTypes.default.bool,
  showChildrenBelow: _propTypes.default.bool
});